/**
 * @generated SignedSource<<7a0906e52f07393b60dd714b4cb41b17>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useRefineMenuClose_appliedFilters$data = ReadonlyArray<{
  readonly name: string | null;
  readonly values: ReadonlyArray<{
    readonly urlLabel: string | null;
  } | null> | null;
  readonly " $fragmentType": "useRefineMenuClose_appliedFilters";
}>;
export type useRefineMenuClose_appliedFilters$key = ReadonlyArray<{
  readonly " $data"?: useRefineMenuClose_appliedFilters$data;
  readonly " $fragmentSpreads": FragmentRefs<"useRefineMenuClose_appliedFilters">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "useRefineMenuClose_appliedFilters",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParamValue",
      "kind": "LinkedField",
      "name": "values",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlLabel",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SearchBrowseParsedParam",
  "abstractKey": null
};

(node as any).hash = "7d44e537cd0d08dae6774109d170a3d2";

export default node;
